import React from 'react'

import Button from "../../button"
import { StyledCareerJobBtn } from "./CareersJobStyles"
import { CareerJobApplyBtnProps } from './CareerJobTypes'


const CareerJobApplyBtn = ({ url }: CareerJobApplyBtnProps) => {
  return (
    <StyledCareerJobBtn>
      <Button
        text="Start Application"
        className="btn--color btn--sm-wide"
        iconName="ArrowRight"
        href={url}
      />
    </StyledCareerJobBtn>
  )
}

export default CareerJobApplyBtn